<template>
  <div class="sospensioni-richieste-table">
    <!-- Header con contatore -->
    <div class="table-toggle-header" @click="aperta = !aperta">
      <div class="flex align-items-center gap-3">
        <i class="pi pi-check-circle" style="color: #4CAF50; font-size: 1.5rem;"></i>
        <h5 class="m-0 ml-2">Sospensioni Richieste</h5>
      </div>
      <div class="flex align-items-center gap-2">
        <Tag :value="`${recordRichieste.length} record`" severity="success"></Tag>
        <Button :icon="aperta ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" class="p-button-text p-button-rounded" />
      </div>
    </div>

    <!-- Tabella collassabile -->
    <transition name="expand">
      <div v-show="aperta" class="table-content">
        <!-- Pannello Filtri Collassabile -->
        <transition name="expand">
          <div v-show="mostraFiltri" class="filtri-panel mb-3">
            <div class="filtri-grid">
              <div class="p-field">
                <label for="filter-cp-utente">CP Utente</label>
                <InputText id="filter-cp-utente" v-model="filters.cp_utente.value" placeholder="Filtra per CP Utente"
                  class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-pod">POD</label>
                <InputText id="filter-pod" v-model="filters.cod_pod.value" placeholder="Filtra per POD"
                  class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-piva-utente">P.IVA Utente</label>
                <InputText id="filter-piva-utente" v-model="filters.piva_utente.value"
                  placeholder="Filtra per P.IVA Utente" class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-piva-gestore">P.IVA Gestore</label>
                <InputText id="filter-piva-gestore" v-model="filters.piva_gestore.value"
                  placeholder="Filtra per P.IVA Gestore" class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-prestazione">Prestazione</label>
                <InputText id="filter-prestazione" v-model="filters.cod_prestazione.value"
                  placeholder="Filtra per prestazione" class="w-full" />
              </div>
              <div class="p-field">
                <label for="filter-contr-disp">Controparte Disp.</label>
                <InputText id="filter-contr-disp" v-model="filters.cod_contr_disp.value"
                  placeholder="Filtra per controparte disp." class="w-full" />
              </div>
            </div>
            <div class="flex justify-content-end gap-2 mt-3">
              <Button label="Reset Filtri" icon="pi pi-filter-slash" class="p-button-outlined p-button-sm"
                @click="resetFiltri" />
            </div>
          </div>
        </transition>

        <DataTable :value="recordFiltrati" :loading="loading" paginator :rows="10" :rowsPerPageOptions="[10, 25, 50]"
          responsiveLayout="scroll" stripedRows v-model:filters="filters" v-model:selection="recordSelezionati"
          dataKey="cp_utente">
          <template #header>
            <div class="table-header-custom">
              <div class="flex align-items-center" style="gap: 0.5rem;">
                <Button label="Aggiorna" icon="pi pi-refresh" class="p-button-outlined p-button-sm"
                  @click="$emit('refresh')" :loading="loading" />
                <Button label="Filtri" :icon="mostraFiltri ? 'pi pi-filter-fill' : 'pi pi-filter'"
                  :class="['p-button-outlined p-button-sm', mostraFiltri ? 'p-button-primary' : '']"
                  @click="mostraFiltri = !mostraFiltri" />
                <Button label="Scarica Selezionati" icon="pi pi-download" class="p-button-success p-button-sm"
                  @click="handleScaricaSelezionati" :disabled="!recordSelezionati || recordSelezionati.length === 0" />
                <Button label="Invia alla PDC" icon="pi pi-send" class="p-button-warning p-button-sm"
                  @click="handleInviaAllaPDC" :disabled="!recordSelezionati || recordSelezionati.length === 0" :loading="loadingInvio" />
              </div>
              <div class="search-box">
                <i class="pi pi-search"></i>
                <InputText v-model="ricercaGlobale" placeholder="Ricerca globale..." class="p-inputtext-sm" />
                <Button v-if="ricercaGlobale" icon="pi pi-times" class="p-button-text p-button-sm p-button-rounded"
                  @click="ricercaGlobale = ''" />
              </div>
            </div>
          </template>

          <template #empty>
            <div class="text-center p-4">Nessun record trovato.</div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 3rem" :exportable="false"></Column>

          <Column field="cp_utente" header="CP Utente" sortable style="min-width: 150px;"></Column>
          <Column field="cod_pod" header="POD" sortable style="min-width: 150px;"></Column>
          <Column field="piva_utente" header="P.IVA Utente" sortable style="min-width: 130px;"></Column>
          <Column field="piva_gestore" header="P.IVA Gestore" sortable style="min-width: 130px;"></Column>
          <Column field="cod_prestazione" header="Prestazione" sortable style="min-width: 120px;"></Column>
          <Column field="cod_contr_disp" header="Controparte Disp." sortable style="min-width: 150px;"></Column>
          <Column field="importo_morosita" header="Importo Morosità" sortable style="min-width: 140px;">
            <template #body="slotProps">
              {{ slotProps.data.importo_morosita !== null && slotProps.data.importo_morosita !== undefined ? `€ ${slotProps.data.importo_morosita}` : '-' }}
            </template>
          </Column>
        </DataTable>
      </div>
    </transition>
  </div>
</template>

<script>
import { defineComponent, ref, computed, watch } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import { useToast } from 'primevue/usetoast';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Tag from 'primevue/tag';
import Service from '@/services/ask-pratiche/invio-pdc';

export default defineComponent({
  name: 'SospensioniRichiesteTable',

  components: {
    DataTable,
    Column,
    Button,
    InputText,
    Tag
  },

  props: {
    recordRichieste: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  emits: ['refresh'],

  setup(props, { emit }) {
    const toast = useToast();
    const service = new Service();

    // Stato
    const aperta = ref(false);
    const mostraFiltri = ref(false);
    const ricercaGlobale = ref('');
    const recordSelezionati = ref([]);
    const loadingInvio = ref(false);

    // Filtri
    const filters = ref({
      cp_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cod_pod: { value: null, matchMode: FilterMatchMode.CONTAINS },
      piva_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
      piva_gestore: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cod_prestazione: { value: null, matchMode: FilterMatchMode.CONTAINS },
      cod_contr_disp: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    // Watch per preservare la selezione quando i dati vengono aggiornati
    watch(() => props.recordRichieste, (newRecords) => {
      if (recordSelezionati.value.length > 0) {
        // Mantieni i record selezionati che esistono ancora nei nuovi dati
        recordSelezionati.value = recordSelezionati.value.filter(selected => 
          newRecords.some(record => record.cp_utente === selected.cp_utente)
        );
      }
    });

    // Computed
    const recordFiltrati = computed(() => {
      if (!ricercaGlobale.value) return props.recordRichieste;

      const searchTerm = ricercaGlobale.value.toLowerCase();
      const searchableFields = [
        'cp_utente', 'cod_pod', 'piva_utente', 'piva_gestore',
        'cod_prestazione', 'cod_contr_disp', 'cf', 'piva'
      ];

      return props.recordRichieste.filter(record => {
        return searchableFields.some(field => {
          const value = record[field];
          return value && value.toString().toLowerCase().includes(searchTerm);
        });
      });
    });

    // Methods
    const formatDate = (dateString) => {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    };

    const resetFiltri = () => {
      filters.value = {
        cp_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cod_pod: { value: null, matchMode: FilterMatchMode.CONTAINS },
        piva_utente: { value: null, matchMode: FilterMatchMode.CONTAINS },
        piva_gestore: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cod_prestazione: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cod_contr_disp: { value: null, matchMode: FilterMatchMode.CONTAINS }
      };
    };

    const handleScaricaSelezionati = () => {
      if (!recordSelezionati.value || recordSelezionati.value.length === 0) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona almeno un record da scaricare',
          life: 3000
        });
        return;
      }

      // Header CSV formato flusso 0050 per SOSPENSIONI (SM1)
      const header = 'COD_SERVIZIO;COD_FLUSSO;PIVA_UTENTE;PIVA_GESTORE;CP_UTENTE;COD_POD;COD_PRESTAZIONE;COD_CONTR_DISP;IMPORTO_MOROSITA;CF;PIVA;CF_STRANIERO;TELEFONO;EMAIL';

      const csvRows = recordSelezionati.value.map(record => [
        'SM1',                                    // COD_SERVIZIO
        '0050',                                   // COD_FLUSSO
        record.piva_utente || '',                 // PIVA_UTENTE
        record.piva_gestore || '',                // PIVA_GESTORE
        record.cp_utente || '',                   // CP_UTENTE
        record.cod_pod || '',                     // COD_POD
        record.cod_prestazione || '',             // COD_PRESTAZIONE
        record.cod_contr_disp || '',              // COD_CONTR_DISP
        record.importo_morosita || '',            // IMPORTO_MOROSITA
        record.cf || '',                          // CF
        record.piva || '',                        // PIVA
        record.cf_straniero || '',                // CF_STRANIERO
        record.telefono || '',                    // TELEFONO
        record.email || ''                        // EMAIL
      ].join(';'));

      const csvContent = [header, ...csvRows].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `sospensioni_selezionate_${new Date().getTime()}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const handleInviaAllaPDC = async () => {
      if (!recordSelezionati.value || recordSelezionati.value.length === 0) {
        toast.add({
          severity: 'warn',
          summary: 'Attenzione',
          detail: 'Seleziona almeno un record da inviare alla PDC',
          life: 3000
        });
        return;
      }

      loadingInvio.value = true;

      try {
        // Header CSV formato flusso 0050 per SOSPENSIONI (SM1)
        const header = 'COD_SERVIZIO;COD_FLUSSO;PIVA_UTENTE;PIVA_GESTORE;CP_UTENTE;COD_POD;COD_PRESTAZIONE;COD_CONTR_DISP;IMPORTO_MOROSITA;CF;PIVA;CF_STRANIERO;TELEFONO;EMAIL';

        const csvRows = recordSelezionati.value.map(record => [
          'SM1',                                    // COD_SERVIZIO
          '0050',                                   // COD_FLUSSO
          record.piva_utente || '',                 // PIVA_UTENTE
          record.piva_gestore || '',                // PIVA_GESTORE
          record.cp_utente || '',                   // CP_UTENTE
          record.cod_pod || '',                     // COD_POD
          record.cod_prestazione || '',             // COD_PRESTAZIONE
          record.cod_contr_disp || '',              // COD_CONTR_DISP
          record.importo_morosita || '',            // IMPORTO_MOROSITA
          record.cf || '',                          // CF
          record.piva || '',                        // PIVA
          record.cf_straniero || '',                // CF_STRANIERO
          record.telefono || '',                    // TELEFONO
          record.email || ''                        // EMAIL
        ].join(';'));

        const csvContent = [header, ...csvRows].join('\n');

        // Crea il file CSV
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const file = new File([blob], `sospensioni_invio_${new Date().getTime()}.csv`, { type: 'text/csv' });

        // Invia alla PDC
        const response = await service.uploadCSVPDC(file, 'sospensioni');

        toast.add({
          severity: 'success',
          summary: 'Invio completato',
          detail: response.message || `${recordSelezionati.value.length} record inviati con successo alla PDC`,
          life: 3000
        });

        // Reset selezione e refresh dati
        recordSelezionati.value = [];
        emit('refresh');

      } catch (error) {
        console.error('Errore invio alla PDC:', error);
        
        const errorMessage = error.response?.data?.message || error.message || 'Errore durante l\'invio alla PDC';
        
        toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: errorMessage,
          life: 5000
        });
      } finally {
        loadingInvio.value = false;
      }
    };

    return {
      aperta,
      mostraFiltri,
      ricercaGlobale,
      recordSelezionati,
      filters,
      recordFiltrati,
      formatDate,
      resetFiltri,
      handleScaricaSelezionati,
      handleInviaAllaPDC,
      loadingInvio
    };
  }
});
</script>

<style scoped>
/* === CONTAINER PRINCIPALE === */
.sospensioni-richieste-table {
  margin-bottom: 2rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* === HEADER COLLASSABILE === */
.table-toggle-header {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border: 1px solid #86efac;
  border-radius: 12px;
  padding: 1.5rem 2rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
  box-shadow: 0 1px 3px rgba(34, 197, 94, 0.08);
}

.table-toggle-header:hover {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  box-shadow: 0 4px 12px rgba(34, 197, 94, 0.15);
}

.table-toggle-header h5 {
  color: #166534;
  font-weight: 700;
  font-size: 1.125rem;
  letter-spacing: -0.01em;
}

.table-toggle-header i {
  filter: drop-shadow(0 2px 4px rgba(34, 197, 94, 0.2));
}

/* === CONTENUTO TABELLA === */
.table-content {
  margin-top: 1rem;
  padding: 0;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

/* === HEADER TABELLA === */
.table-header-custom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
  padding: 1.5rem 1.5rem 1rem;
  border-bottom: 1px solid #e5e7eb;
}

/* === SEARCH BOX === */
.search-box {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  min-width: 280px;
  flex: 1;
  max-width: 400px;
  transition: all 0.2s ease;
}

.search-box:focus-within {
  background: #ffffff;
  border-color: #9ca3af;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.08);
}

.search-box i.pi-search {
  color: #6b7280;
  font-size: 0.95rem;
}

.search-box .p-inputtext {
  border: none;
  background: transparent;
  box-shadow: none;
  flex: 1;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
}

.search-box .p-inputtext:focus {
  box-shadow: none;
}

/* === PANNELLO FILTRI === */
.filtri-panel {
  background: #ffffff;
  padding: 2rem;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  margin: 1.5rem;
}

.filtri-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
}

.p-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.p-field label {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.p-field input {
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.p-field input:focus {
  border-color: #4ade80;
  box-shadow: 0 0 0 3px rgba(74, 222, 128, 0.08);
}

/* === DATA TABLE STYLING === */
:deep(.p-datatable) {
  border-radius: 0;
}

:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: linear-gradient(to bottom, #f9fafb 0%, #f3f4f6 100%);
  color: #166534;
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 1rem;
  border-bottom: 1px solid #86efac;
}

:deep(.p-datatable .p-datatable-tbody > tr) {
  transition: all 0.2s ease;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f0fdf4 !important;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 1rem;
  color: #374151;
  font-size: 0.9rem;
  border-bottom: 1px solid #f3f4f6;
}

:deep(.p-datatable .p-datatable-tbody > tr > td:first-child) {
  font-weight: 600;
  color: #166534;
}

:deep(.p-paginator) {
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  padding: 1rem;
}

/* === BUTTONS === */
:deep(.p-button-outlined) {
  border-width: 1px;
  font-weight: 600;
  transition: all 0.2s ease;
}

:deep(.p-button-outlined:hover) {
  background-color: rgba(0, 0, 0, 0.02);
}

/* === TAG STYLING === */
:deep(.p-tag) {
  font-weight: 600;
  padding: 0.5rem 1rem;
  border-radius: 6px;
}

/* === ANIMAZIONI === */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
}

.expand-enter-from {
  opacity: 0;
  transform: scaleY(0.95) translateY(-10px);
}

.expand-leave-to {
  opacity: 0;
  transform: scaleY(0.95) translateY(-5px);
}

.expand-enter-to,
.expand-leave-from {
  opacity: 1;
  transform: scaleY(1) translateY(0);
}

/* === RESPONSIVE === */
@media (max-width: 1024px) {
  .filtri-grid {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }
}

@media (max-width: 768px) {
  .table-toggle-header {
    padding: 1.25rem 1.5rem;
  }

  .table-header-custom {
    flex-direction: column;
    align-items: stretch;
    padding: 1rem;
  }

  .search-container {
    width: 100%;
    max-width: 100%;
    min-width: auto;
  }

  .filtri-panel {
    padding: 1.5rem;
    margin: 1rem;
  }

  .filtri-grid {
    grid-template-columns: 1fr;
  }
}
</style>